import { Cardinal } from '../../models/core/cardinal.js';
import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../models/dto/data-model.js';
import { isSameData } from '../../models/dto/data-model-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class TicketCartLimitComponent extends Component {
  static readonly TYPE_ID: string = '7f90fcbe8efa4205abb5988ef6e2de77';

  constructor(
    public readonly cartLimit: Cardinal,
  ) {
    super();
  }

  get $typeId(): string {
    return TicketCartLimitComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): TicketCartLimitComponent {
    return new TicketCartLimitComponent(
        Cardinal.decode(MapUtils.getNumber(map, 'cartLimit')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      cartLimit: this.cartLimit.encode(),
    };
  }

  clone(): this {
    return new TicketCartLimitComponent(
        this.cartLimit.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.cartLimit, this.cartLimit);
  }
}

export class TicketCartLimitComponentBuilder extends DataModelBuilder<TicketCartLimitComponent> {
  build(context: SerializationContext, map: SerializedData): TicketCartLimitComponent {
    return TicketCartLimitComponent.fromMap(context, map);
  }
}
